module.exports = __webpack_public_path__ + "img/mypage_01.c2f1aef1.png";